import client from './api-client';

export const getConfiguracionForm16 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form16: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getParametrosFecha = async(query) => {
    try {
        
        const response = await client.getImplicado(`parametros?q=${query}`);
     
        if (response.status === 200 && response.data.code === 1) {
            return {
                parametros: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDatosCartaCIATercero = async(query) => {
    try {
        
        const response = await client.get(`caso/implicado?q=${query}`);
        
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosCIATErcero: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getTipoVehiculos= async(query) => {
    try {
        
        const response = await client.getSelect(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboTipoVehiculos: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getMarcas= async(query) => {
    try {
        
        const response = await client.getSelect(`marcas?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboMarcas: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getMontosInformados= async(query) => {
    try {
        
        const response = await client.get(`recobro/montos?q=${query}`);
       (response, "Respuesta Montos Informados");
        
        if (response.status === 200 && response.data.code === 1) {
            return {
                montosInformados: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getcompanias= async(query) => {
    try {
        
        const response = await client.getSelect(`companias?q=${query}`);
              
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboCompanias: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const postActualizarCIA = async(file) => {
    try {
        
        const response = await client.post('recobro/carta-cia-tercero', file);
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaModalCIA: response.data};
        } else {
            return {respuestaModalCIA: response.data};
        }

    } catch(error){
        throw error;
    }
}
export const getSolicitudDescuento = async(query) => {
    try {
        
        const response = await client.getSelect(`gestion-implicado/sol-descuento?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                solicitudDescuento: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}